var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.statusInfo)?_c('div',{staticClass:"badge text-white legend-pill",class:{ crossed: _vm.crossed, clickable: _vm.clickable, 'badge-pill': _vm.rounded, 'px-3 text-uppercase': _vm.big },staticStyle:{"font-size":"0.688rem"},style:({
    'background-color': _vm.statusInfo.color
  })},[_vm._v(" "+_vm._s(_vm.statusInfo.desc)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }